import { render, staticRenderFns } from "./OfficeBalanceCard.vue?vue&type=template&id=53f46d58&scoped=true&"
import script from "./OfficeBalanceCard.vue?vue&type=script&lang=js&"
export * from "./OfficeBalanceCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficeBalanceCard.vue?vue&type=style&index=0&id=53f46d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f46d58",
  null
  
)

export default component.exports